import { Dropzone } from '@dropzone-ui/react';
import { useFunctionsButtons } from '../../../../hooks/use-function-button.hook';
import useBgPages from '../../../../hooks/use-bg-pages.hook';
import Input from '../../../../components/forms/input.component';
import Icon from '../../../../components/forms/icon.component';
import SimpleTitle from '../../../../components/forms/simple-titles.component';
import React from 'react';

function richCard({
  index,
  actionElement
}: {
  index: number;
  actionElement: any;
  actionCounts: any;
}) {
  useBgPages();
  const { t, register, watch, errors, setValue, handleRemoveElement, files, handleUpdateFiles } =
    useFunctionsButtons();

  return (
    <React.Fragment key={`contentInfo-${index}`}>
      <div key={`contenInfo-${actionElement}`} className="p-1">
        <div className="d-flex justify-content-between align-items-center">
          <SimpleTitle
            title={
              <span className="fw-bold fs-4">
                <span className="">Media</span>
              </span>
            }
            subtitle={<span className="">Selecciona que tipo de archivo quieres enviar</span>}
          />
          <div className="d-flex gap-2 mb-10">
            <button
              type="button"
              className="btn btn-light-danger p-1 ms-2 hover-scale"
              onClick={() => handleRemoveElement(index)}
            >
              <Icon icon="ki-abstract-11" size="fs-3" className="ms-1 fw-bolder" />
            </button>
          </div>
        </div>
        <div
          key={`${actionElement.type}_${index}`}
          className="accordion accordion-icon-toggle mb-5"
          id={`acordion_onlyCard.${index}`}
        >
          <div
            className="accordion-header collapsed py-3 d-flex"
            data-bs-target={`#acordion_onlyCard_item_.${index}`}
            data-bs-toggle="collapse"
            aria-expanded="false"
          >
            <span className="accordion-icon">
              <Icon icon="ki-arrow-right" size="fs-1" />
            </span>
            <h4 className="fs-6 fw-semibold mb-0 ms-4 text-primary fw-bolder mt-1">
              Mostra campos
            </h4>
          </div>
          <div
            className="fs-6 collapse ps-10"
            data-bs-parent={`#acordion_onlyCard.${index}`}
            id={`acordion_onlyCard_item_.${index}`}
          >
            <div className="mb-10 mt-0 border p-10 rounded-12">
              <div className="row mb-10">
                <label className="form-label">
                  Tipo de media
                  <span className="fs-8 text-muted ms-1 required"></span>
                </label>
                <div className="col-4">
                  <div key="1" data-kt-buttons="true">
                    <label
                      className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 mb-0 ${
                        watch(`elements.${index}.imageCheck`) ? 'active' : ''
                      }`}
                    >
                      <div className="d-flex align-items-center me-2">
                        <div className="form-check form-check-custom form-check-solid form-check-primary me-6">
                          <input
                            className="form-check-input st-b"
                            type="radio"
                            name={`elements.${index}.imageCheck`}
                            checked={watch(`elements.${index}.imageCheck`)}
                            onChange={() => {
                              const isChecked = watch(`elements.${index}.imageCheck`);
                              setValue(`elements.${index}.imageCheck`, !isChecked);
                              if (!isChecked) {
                                setValue(`elements.${index}.videoCheck`, false);
                                setValue(`elements.${index}.URLVideo`, '');
                                setValue(`elements.${index}.URLImagePoster`, '');
                                setValue(`elements.${index}.fileCheck`, false);
                                setValue(`elements.${index}.URLFile`, '');
                              }
                            }}
                          />
                        </div>
                        <div className="flex-grow-1">
                          <h2 className="d-flex align-items-center fs-3 fw-bold flex-wrap">
                            {t('templates.rcs.create.image-title')}
                          </h2>
                        </div>
                      </div>
                      <div className="ms-5">
                        <Icon icon="ki-picture" size="fs-2x" type="dark" />
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-4">
                  <div key="2" data-kt-buttons="true">
                    <label
                      className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 mb-0 ${
                        watch(`elements.${index}.videoCheck`) ? 'active' : ''
                      }`}
                    >
                      <div className="d-flex align-items-center me-2">
                        <div className="form-check form-check-custom form-check-solid form-check-primary me-6">
                          <input
                            className="form-check-input st-b"
                            type="radio"
                            name={`elements.${index}.videoCheck`}
                            checked={watch(`elements.${index}.videoCheck`)}
                            onChange={() => {
                              const isChecked = watch(`elements.${index}.videoCheck`);
                              setValue(`elements.${index}.videoCheck`, !isChecked);
                              if (!isChecked) {
                                setValue(`elements.${index}.imageCheck`, false);
                                setValue(`elements.${index}.URLImage`, '');
                                setValue(`elements.${index}.fileCheck`, false);
                                setValue(`elements.${index}.URLFile`, '');
                              }
                            }}
                          />
                        </div>
                        <div className="flex-grow-1">
                          <h2 className="d-flex align-items-center fs-3 fw-bold flex-wrap">
                            {t('templates.rcs.create.video-title')}
                          </h2>
                        </div>
                      </div>
                      <div className="ms-5">
                        <Icon icon="ki-google-play" size="fs-2x" type="dark" />
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-4">
                  <div key="2" data-kt-buttons="true">
                    <label
                      className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 mb-0 ${
                        watch(`elements.${index}.fileCheck`) ? 'active' : ''
                      }`}
                    >
                      <div className="d-flex align-items-center me-2">
                        <div className="form-check form-check-custom form-check-solid form-check-primary me-6">
                          <input
                            className="form-check-input st-b"
                            type="radio"
                            name={`elements.${index}.fileCheck`}
                            checked={watch(`elements.${index}.fileCheck`)}
                            onChange={() => {
                              const isChecked = watch(`elements.${index}.fileCheck`);
                              setValue(`elements.${index}.fileCheck`, !isChecked);
                              if (!isChecked) {
                                setValue(`elements.${index}.imageCheck`, false);
                                setValue(`elements.${index}.URLVideo`, '');
                                setValue(`elements.${index}.URLImagePoster`, '');
                                setValue(`elements.${index}.URLImage`, '');
                                setValue(`elements.${index}.videoCheck`, false);
                              }
                            }}
                          />
                        </div>
                        <div className="flex-grow-1">
                          <h2 className="d-flex align-items-center fs-3 fw-bold flex-wrap">
                            Archivo
                          </h2>
                        </div>
                      </div>
                      <div className="ms-5">
                        <Icon icon="ki-file-sheet" size="fs-2x" type="dark" />
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              {(watch(`elements.${index}.videoCheck`) ||
                watch(`elements.${index}.imageCheck`) ||
                watch(`elements.${index}.fileCheck`)) && (
                <>
                  <div className="row mb-7">
                    <div className="col-md-10 mt-4">
                      {files.length === 0 && (
                        <Dropzone
                          onChange={(files) =>
                            handleUpdateFiles(
                              files,
                              index,
                              'richCard',
                              watch(`elements.${index}.videoCheck`)
                                ? 'headerVideo'
                                : watch(`elements.${index}.imageCheck`)
                                  ? 'headerImage'
                                  : watch(`elements.${index}.fileCheck`)
                                    ? 'headerFile'
                                    : '',
                              0
                            )
                          }
                          value={files}
                          className="dropzone cursor-default bg-light"
                          accept={
                            watch(`elements.${index}.videoCheck`)
                              ? '.mp4'
                              : watch(`elements.${index}.imageCheck`)
                                ? '.png, .jpg, .jpeg, .gif'
                                : '.pdf, .doc, .docx, .txt, .zip, .csv, .rar, .pptx, .xls, .xlsx'
                          }
                          maxFiles={1}
                        >
                          <div className="dz-message needsclick">
                            <Icon
                              icon={`ki ${watch(`elements.${index}.videoCheck`) ? 'ki-google-play' : watch(`elements.${index}.imageCheck`) ? 'ki-picture' : 'ki-file'}`}
                              size="fs-3x"
                              type="primary"
                            />
                            <div className="ms-4">
                              <h3 className="fs-7 fw-bold text-gray-900 mb-0">
                                {t('templates.rcs.create.drag-file')}
                              </h3>
                              <div className="d-flex flex-column">
                                <span className="d-block fs-9 fw-semibold text-muted mb-1">
                                  {watch(`elements.${index}.videoCheck`)
                                    ? '.mp4'
                                    : watch(`elements.${index}.imageCheck`)
                                      ? '.png, .jpg, .jpeg o .gif'
                                      : watch(`elements.${index}.fileCheck`)
                                        ? '.pdf, .doc, .docx, .txt, .zip, .rar, .pptx, .xls, .xlsx o .csv'
                                        : ''}
                                </span>

                                <span className="fs-8 fw-semibold text-info">
                                  {watch(`elements.${index}.videoCheck`)
                                    ? 'Video'
                                    : watch(`elements.${index}.imageCheck`)
                                      ? 'Imagen (resolución: 1440 × 720 px)'
                                      : watch(`elements.${index}.fileCheck`)
                                        ? 'Archivo'
                                        : ''}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Dropzone>
                      )}
                    </div>
                  </div>
                </>
              )}
              {watch(`elements.${index}.imageCheck`) && (
                <div className="fv-row mb-10">
                  <Input
                    label={t('templates.rcs.create.url-image-label')}
                    requiredIndicator="required"
                    placeholder="https://www.dominio.com/nombre-imagen.jpg"
                    errors={errors?.elements?.[index]?.URLImage}
                    {...register(`elements.${index}.URLImage`, {
                      required: true,
                      pattern: {
                        value: /^(https?:\/\/.*\.(?:png|jpg|jpeg|gif))$/i,
                        message:
                          'La URL no es válida los formatos deben ser .png .jpg .jpeg o .gif, ejemplo: https://www.dominio.com/nombre-imagen.jpg'
                      }
                    })}
                  />
                </div>
              )}
              {watch(`elements.${index}.videoCheck`) && (
                <>
                  <div className="fv-row mb-7">
                    <Input
                      label={t('templates.rcs.create.url-video-label')}
                      requiredIndicator="required"
                      placeholder="https://www.dominio.com/nombre-video.mp4"
                      errors={errors?.elements?.[index]?.URLVideo}
                      {...register(`elements.${index}.URLVideo`, {
                        required: true,
                        pattern: {
                          value: /^(https?:\/\/.*\.(?:mp4))$/i,
                          message:
                            'La URL no es válida el formato debe ser .mp4, ejemplo: https://www.dominio.com/nombre-video.mp4'
                        }
                      })}
                    />
                  </div>
                </>
              )}
              {watch(`elements.${index}.fileCheck`) && (
                <div className="fv-row mb-10">
                  <Input
                    label={'URL de archivo'}
                    requiredIndicator="required"
                    placeholder="https://www.dominio.com/nombre-archivo.jpg"
                    errors={errors?.elements?.[index]?.URLFile}
                    {...register(`elements.${index}.URLFile`, {
                      required: true,
                      pattern: {
                        value: /^(https?:\/\/.*\.(?:pdf|doc|docx|txt|zip|rar|pptx|xls|xlsx|csv))$/i,
                        message:
                          'La URL no es válida los formatos deben ser .pdf, .doc, .docx, .txt, .zip, .rar, .pptx, .xls, .xlsx o .csv, ejemplo: https://www.dominio.com/nombre-archivo.pdf'
                      }
                    })}
                  />
                </div>
              )}
              {(watch(`elements.${index}.fileCheck`) || watch(`elements.${index}.videoCheck`)) && (
                <>
                  <div className="row mb-7">
                    <div className="col-md-10">
                      <Dropzone
                        onChange={(files) =>
                          handleUpdateFiles(files, index, 'richCard', 'posterImage', 0)
                        }
                        className="dropzone cursor-default bg-light"
                        accept=".png, .jpg, .jpeg, .gif"
                        maxFiles={1}
                      >
                        <div className="dz-message needsclick">
                          <Icon icon="ki-picture" size="fs-3x" type="primary" />
                          <div className="ms-4">
                            <h3 className="fs-7 fw-bold text-gray-900 mb-0">
                              {t('templates.rcs.create.drag-file')}
                            </h3>
                            <div className="d-flex flex-column">
                              <span className="d-block fs-9 fw-semibold text-muted mb-1">
                                .png .jpg .jpeg o .gif
                              </span>

                              <span className="fs-8 fw-semibold text-info">
                                Poster de video (.png .jpg .jpeg o .gif 1440 X 720px)
                              </span>
                            </div>
                          </div>
                        </div>
                      </Dropzone>
                    </div>
                  </div>
                  <div className="fv-row mb-10">
                    <Input
                      label={t('templates.rcs.create.url-poster-video-label')}
                      requiredIndicator="required"
                      placeholder=" https://www.dominio.com/nombre-poster.jpg"
                      errors={errors?.elements?.[index]?.URLImagePoster}
                      {...register(`elements.${index}.URLImagePoster`, {
                        required: true,
                        pattern: {
                          value: /^(https?:\/\/.*\.(?:png|jpg|jpeg|gif))$/i,
                          message:
                            'La URL no es válida. Los formatos deben ser .png .jpg .jpeg o .gif, ejemplo: https://www.dominio.com/nombre-poster.jpg'
                        }
                      })}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default richCard;
